import React from 'react';
import {
    PanelResizeHandle,
    usePanelGroupContext,
} from 'react-resizable-panels';
import './style.scss';
import IconDrag from 'svgIcons/MotionPortalIcons/IconDrag';
// eslint-disable-next-line import/no-unused-modules
export function ResizeHandle({
    className = '',
    id,
    ...rest
}) {
    const { direction } = usePanelGroupContext();

    return (
        <PanelResizeHandle
            className={['ResizeHandle', className].join(' ')}
            id={id}
            {...rest}
            direction={direction}
            withHandleButton={true}
            withHandleButtonIcon={true}
        >
            <IconDrag
                className={'ResizeHandleThumb'}

            />
        </PanelResizeHandle>
    );
}
